import React from 'react';
import AISmartcontent from 'pages/AdminClient/RedactionIA/AISmartcontent';

export default function ConsultantIASmartcontent(props) {
  return <AISmartcontent {...props} consultantMode />;
}
